<template>
  <div class="zmanim-map__container">
    <div
      ref="mapContainer"
      :style="containerStyle"
      class="map-markers__container"
    />
    <div class="zmanim-map__caption">
      {{ caption || " " }}
      <!-- <div id="embed-api-auth-container"></div> -->
    </div>
  </div>
</template>

<script>
// Used for generating static json file.
import uuid from 'uuid/v4'

// rendering the map. (Note: There's a related CSS file in index.html.)
const mapboxgl = require('mapbox-gl/dist/mapbox-gl.js')

const maxResults = 900000
const oneRemInPx = parseFloat(
  getComputedStyle(document.documentElement).fontSize
)
const liveUrl = 'https://ultimatezmanim.app/api/live.geojson'

export default {
  name: 'ZmanimMap',
  data () {
    return {
      markers: [],
      mapSize: {
        height: 375 / oneRemInPx,
        width: 767 / oneRemInPx
      },
      ids: ['ga:96151885'],
      caption: undefined,
      socket: undefined,
      map: undefined,
      liveData: {
        type: 'FeatureCollection',
        features: []
      }
    }
  },
  computed: {
    containerStyle () {
      return {
        '--zmn-map-width': `${this.mapSize.width}rem`,
        '--zmn-map-height': `${this.mapSize.height}rem`
      }
    },
    useLiveData () {
      return this.$route.params.source === 'live'
    }
  },
  mounted () {
    // this.loadMapData();
    this.renderMap()
    // if (useLiveData) {
    //   this.loadMapData();
    // } else {
    //   this.markers = map;
    // }
  },
  methods: {
    renderTopCountriesChart (ids) {
      this.query({
        ids,
        dimensions: 'ga:country, ga:city, ga:latitude, ga:longitude',
        metrics: 'ga:visitors',
        sort: '-ga:visitors',
        'max-results': maxResults,
        'start-date': '3650daysAgo'
      })
        .then(response => {
          // const colors = ['#4D5360', '#949FB1', '#D4CCC5', '#E2EAE9', '#F7464A'];
          const rows = response.rows
          if (!rows || !rows.filter) {
            return
          }
          this.markers = rows.filter((row) => { // eslint-disable-line
            return parseInt(row[2], 10) !== 0 && parseInt(row[3], 10) !== 0
          })
            .map(row => this.markerFromRow(row))
          // const geoJSON = {
          //   type: 'FeatureCollection',
          //   features: this.markers,
          // };
          // console.log(JSON.stringify(geoJSON, null, 2)); // eslint-disable-line
          // debugger;
          // resolve(geoJSON);
        })
        .catch(error => {
          console.log(error); // eslint-disable-line
        })
    },
    markerFromRow (row) {
      const marker = {
        type: 'Feature',
        properties: {
          n: `${row[1]}, ${row[0]}`,
          i: uuid()
        },
        geometry: {
          type: 'Point',
          coordinates: [parseFloat(row[3]), parseFloat(row[2])]
        }
      }

      if (row[1] === '(not set)') {
        marker.city = marker.country
      }
      return marker
    },
    /**
     * Extend the Embed APIs `gapi.analytics.report.Data` component to
     * return a promise the is fulfilled with the value returned by the API.
     * @param {Object} params The request parameters.
     * @return {Promise} A promise.
     */
    query (params) {
      return new Promise((resolve, reject) => {
        const gapi = window.gapi
        const data = new gapi.analytics.report.Data({ query: params })
        data
          .once('success', response => {
            // debugger;
            resolve(response)
          })
          .once('error', response => {
            reject(response)
          })
          .execute()
      })
    },
    // loadMapData() {
    //   const gapi = window.gapi;
    //   gapi.analytics.ready(() => {
    //     /**
    //     * Authorize the user immediately if the user has already granted access.
    //     * If no access has been created, render an authorize button inside the
    //     * element with the ID "embed-api-auth-container".
    //     */
    //     gapi.client.init({
    //       apiKey: 'AIzaSyAoOVItbLaGdykqJaYBvhufnhkAS5CQ7lY',
    //     });
    //     // const ids = this.ids;
    //     // const t = this;

    //     gapi.analytics.auth.on('signIn', () => {
    //       // this.renderTopCountriesChart(ids);
    //       // t.renderRealTimeUsers(ids);
    //     });
    //     gapi.analytics.auth.authorize({
    //       container: 'embed-api-auth-container',
    //       clientid: '184448953949-lhn6u3aofit83aklh3b36mqhqcqbpi15.apps.googleusercontent.com',
    //     });
    //     // .then(() => {
    //     //   this.renderTopCountriesChart(ids);
    //     //   t.renderRealTimeUsers(ids);
    //     // });
    //   });
    // },
    renderMap () {
      mapboxgl.accessToken =
        'pk.eyJ1IjoibW9zaGViZXJtYW4iLCJhIjoiY2prdW5kbmhkMDMyMjN2bWsxaWFraXhwciJ9.pOqa4XwcvMx9H5HJZGxDzQ'
      const container = this.$refs.mapContainer
      /*
      MapBox uses the projection known as EPSG:3857 (http://epsg.io/3857)
      Formerly known as EPSG:900913, for "Google" the correct name is 3857.

      Aspect ratio is ~2.11. (180 - (-180))/(85.06 * 2) = 2.11615
      */
      const northEastCorner = [180, 85.06]
      const southWestCorner = [-180, -85.06]
      const map = new mapboxgl.Map({ // eslint-disable-line
        container,
        dragRotate: false,
        attributionControl: false,
        style: 'mapbox://styles/mapbox/dark-v9?optimize=true',
        zoom: 1,
        // maxZoom: 6,
        minZoom: 0,
        maxBounds: [southWestCorner, northEastCorner]
      })
      this.map = map

      /* Stupid hack because CSS. */
      const canvas = map.getCanvas()
      if (canvas) {
        canvas.style.left = 0
        canvas.style.borderRadius = '0.625rem'
      }

      const nav = new mapboxgl.NavigationControl({ showCompass: false })
      map.addControl(nav, 'bottom-right')
      // map.addControl(new mapboxgl.FullscreenControl());
      // map.addControl(new mapboxgl.GeolocateControl());
      /* Shamelessly borrowed from the Mapbox tutorials at URLS such as:
       https://www.mapbox.com/mapbox-gl-js/example/heatmap-layer/
       */
      map.on('load', () => {
        map.addSource('points', {
          type: 'geojson',
          data: 'https://ultimatezmanim.app/api/map.geojson'
        })

        map.addSource('live', {
          type: 'geojson',
          data: liveUrl
        })

        /* Heatmap */
        map.addLayer({
          id: 'users-heatmap',
          type: 'heatmap',
          source: 'points',
          maxzoom: 9,
          paint: {
            // Increase the heatmap weight based on frequency and property magnitude
            'heatmap-weight': [
              'interpolate',
              ['linear'],
              ['get', 'mag'],
              0,
              0,
              6,
              1
            ],
            // Increase the heatmap color weight weight by zoom level
            // heatmap-intensity is a multiplier on top of heatmap-weight
            'heatmap-intensity': [
              'interpolate',
              ['linear'],
              ['zoom'],
              0,
              1,
              9,
              3
            ],
            // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
            // Begin color ramp at 0-stop with a 0-transparancy color
            // to create a blur-like effect.
            'heatmap-color': [
              'interpolate',
              ['linear'],
              ['heatmap-density'],
              0,
              'rgba(33,102,172,0.1)',
              0.2,
              'rgba(255, 133, 17, 0.2)',
              0.4,
              'rgb(209,229,240)',
              0.6,
              'rgb(253,219,199)',
              0.8,
              'rgb(239,138,98)',
              1,
              'rgba(255, 133, 17, 1)'
            ],
            // Adjust the heatmap radius by zoom level
            'heatmap-radius': [
              'interpolate',
              ['linear'],
              ['zoom'],
              0,
              2,
              9,
              20
            ],
            // Transition from heatmap to circle layer by zoom level
            'heatmap-opacity': ['interpolate', ['linear'], ['zoom'], 7, 1, 9, 0]
          }
        })

        /* User markers. */
        map.addLayer({
          id: 'users-points',
          type: 'circle',
          source: 'points',
          minzoom: 7,
          paint: {
            // Size circle radius by earthquake magnitude and zoom level
            'circle-radius': [
              'interpolate',
              ['linear'],
              ['zoom'],
              7,
              ['interpolate', ['linear'], ['get', 'mag'], 1, 1, 6, 4],
              16,
              ['interpolate', ['linear'], ['get', 'mag'], 1, 5, 6, 50]
            ],
            // Color circle by earthquake magnitude
            'circle-color': [
              'interpolate',
              ['linear'],
              ['get', 'mag'],
              1,
              'rgba(33,102,172,0)',
              2,
              'rgb(103,169,207)',
              3,
              'rgb(209,229,240)',
              4,
              'rgb(253,219,199)',
              5,
              'rgb(239,138,98)',
              6,
              'rgb(178,24,43)'
            ],
            'circle-stroke-color': 'white',
            'circle-stroke-width': 1,
            // Transition from heatmap to circle layer by zoom level
            'circle-opacity': ['interpolate', ['linear'], ['zoom'], 7, 0, 8, 1]
          }
        })

        /* Live Circles */
        map.addLayer({
          id: 'live-points',
          type: 'circle',
          source: 'live',
          minzoom: 0,
          paint: {
            'circle-radius': [
              'interpolate',
              ['linear'],
              ['zoom'],
              7,
              ['interpolate', ['linear'], ['get', 'mag'], 1, 1, 6, 4],
              16,
              ['interpolate', ['linear'], ['get', 'mag'], 1, 5, 6, 50]
            ],
            'circle-color': '#22cc22',
            'circle-stroke-color': 'white',
            'circle-stroke-width': 2,
            'circle-opacity': 1
          }
        })

        window.setInterval(() => {
          map.getSource('live').setData(liveUrl)
        }, 2000)
        // const nav = new mapboxgl.NavigationControl();
        // map.addControl(nav, 'bottom-right');

        /* Popup */
        const popup = new mapboxgl.Popup({
          closeButton: false,
          closeOnClick: false
        })

        const showPopup = e => {
          // Change the cursor style as a UI indicator.
          map.getCanvas().style.cursor = 'pointer'

          const coordinates = e.features[0].geometry.coordinates.slice()
          const description = e.features[0].properties.n

          // Ensure that if the map is zoomed out such that multiple
          // copies of the feature are visible, the popup appears
          // over the copy being pointed to.
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
          }

          // Populate the popup and set its coordinates
          // based on the feature found.
          popup
            .setLngLat(coordinates)
            .setHTML(description)
            .addTo(map)
        }

        const removePopup = () => {
          map.getCanvas().style.cursor = ''
          popup.remove()
        }

        map.on('mouseenter', 'users-points', showPopup)
        map.on('mouseleave', 'users-points', removePopup)
        map.on('mouseenter', 'live-points', showPopup)
        map.on('mouseleave', 'live-points', removePopup)
      })
      // debugger;
    }
  }
}
</script>

<style scoped>
.zmanim-map__container {
  width: var(--zmn-map-width);
  height: var(--zmn-map-height);
}

.zmanim-map__caption {
  font-family: "Avenir-Heavy";
  font-size: 0.875rem;
  color: #332924;
  letter-spacing: 0;
  text-align: center;
  margin-top: 0.94rem;
  margin-bottom: 0.75rem;
}

.map-markers__container {
  background-color: rgba(142, 142, 147, 0.15);
  border-radius: 0.625rem;
  align-self: center;
  margin: 0 auto;
  display: block;
  width: var(--zmn-map-width);
  height: var(--zmn-map-height);
  /* background-image: url('/static/map/map@3x.png'); */
  background-size: var(--zmn-map-width) var(--zmn-map-height);
  background-repeat: no-repeat;
  padding: 0;
  /* object-fit: contain; */
  /* background-position: center; */
}

.map-markers__marker {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #ff851155;
  height: 4px;
  width: 4px;
  margin-top: calc(var(--zmn-y) - 1.5px);
  margin-left: calc(var(--zmn-x) - 1.5px);
  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.75);
  transform: scale(var(--zmn-transform));
  opacity: var(--zmn-transform);
}

.map-markers__marker:hover {
  background: #ff8511;
  transform: scale(1);
  opacity: 1;
}

.map-markers__marker::before {
  display: flex;
  flex-grow: 10;
  flex-shrink: 0;
  height: fit-content;
  content: attr(data-city);
  width: fit-content;
  white-space: nowrap;
  font-family: "Avenir-Medium";
  font-size: 0.875rem;
  color: #fff;
  padding: 0.25rem 0.8125rem;
  border-radius: 0.625rem;
  background: rgba(51, 41, 36, 0.85);
  -webkit-backdrop-filter: blur(1rem);
  transform: scale(0.1);
  z-index: 2147483647;
  opacity: 0;
  margin-bottom: 0;
  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.75);
}

.map-markers__marker:hover::before {
  transform: scale(1);
  margin-bottom: 3rem;
  z-index: 2147483647;
  opacity: 1;
}
</style>
